/**
 * The OTC (over-the-counter) terminal login contract.
 *
 * These are the credentials a location's staff read off a screen and hand to whoever is running
 * the counter that shift — not a personal account, and not hashed: `otc_users.pin` is a plain
 * `varchar(10)` in the database, storing something closer to a shared till code than a password.
 * This contract keeps that shape rather than introducing a hashing scheme the table was never
 * built to support; treating it otherwise would let the dashboard display a PIN it could no
 * longer read back, which is the one thing this screen exists to do.
 *
 * `location_id` is `not null` — same as a terminal, a login is meaningless without knowing which
 * location's counter it unlocks — so this is a per-location nested resource, never a fleet-wide
 * list.
 */
import { z } from 'zod';
import { nonEmptyUpdate } from './content/common.js';
const otcUserEditableShape = {
    username: z.string().min(1).max(100),
    pin: z.string().min(1).max(10),
    role: z.string().min(1).max(50),
};
export const otcUserSchema = z.object({
    id: z.number().int().positive(),
    locationId: z.number().int().positive(),
    ...otcUserEditableShape,
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime().nullable(),
});
export const otcUserListSchema = z.array(otcUserSchema);
export const createOtcUserSchema = z.object(otcUserEditableShape).extend({
    role: otcUserEditableShape.role.optional(),
});
export const updateOtcUserSchema = nonEmptyUpdate(z.object(otcUserEditableShape));
//# sourceMappingURL=otc-users.js.map